import { prepareDocForUpdate } from './helpers/firestoreHelpers'

const updateOrg = (orgRef, values) => {
  return orgRef
    .set(prepareDocForUpdate(values), {merge: true})
}

export default updateOrg
